export const SIGN_UP_LOADING_START_MARK = 'SIGN_UP_LOADING_START_MARK';
export const DEVOPS_LOADING_START_MARK = 'DEVOPS_LOADING_START_MARK';

export function markSignUpLoadingStart() {
  performance.mark(SIGN_UP_LOADING_START_MARK);
}

export function markDevopsLoadingStart() {
  performance.mark(DEVOPS_LOADING_START_MARK);
}

export function getDevopsTimeToInteractive() {
  performance.measure(
    'devopsTimeToInteractivePerformance',
    SIGN_UP_LOADING_START_MARK,
    DEVOPS_LOADING_START_MARK
  );

  return performance
    .getEntriesByType('measure')
    .find(
      (measureEntry) =>
        measureEntry.name === 'devopsTimeToInteractivePerformance'
    )?.duration;
}
